// @ts-check

import { MapContainer } from "react-leaflet";
import { MapsProvider } from "../contexts/maps-context";
import {
  Row
} from "antd";
import { hasAccess, ROLES } from "../utils/AccessLevels";
import { AccessGate } from "../components/AccessGate";

export default function GardensList2() {
  return (
    <MapContainer center={[30, -41]} style={{ borderRadius: 0, height: "calc(100vh - 48px)" }} zoom={2} zoomControl={false}>
      <MapsProvider>
        <MapsProvider.Container>
          <MapsProvider.GardensLayersControl className="leaflet-filters" position="topleft">
            <MapsProvider.GardensListSelect selectProps={{ defaultOpen: true, listHeight: 520 }} />

            <MapsProvider.FiltersCard>
              <MapsProvider.FilterDevicesByBattery />
              <MapsProvider.FilterDevicesByModel />
              <MapsProvider.FilterGardensByTags />
            </MapsProvider.FiltersCard>

            <MapsProvider.ExpandFilterIconButton />
            <MapsProvider.OrderGardensButton />
            <MapsProvider.AddGardenButton />
          </MapsProvider.GardensLayersControl>

          <MapsProvider.BatchOptimizationButton>
            <Row gutter={[10, 10]} justify="end">
              <MapsProvider.ManageGardenOptimizationsButton />
              <AccessGate role={ROLES.TECHNICAL_ADMIN}>
                <MapsProvider.BatchWateringStatusButton />
              </AccessGate>
            </Row>
          </MapsProvider.BatchOptimizationButton>

          <MapsProvider.GardensDevicesByModel />
          <MapsProvider.GardensAreas />
        </MapsProvider.Container>
      </MapsProvider>
    </MapContainer>
  );
}
